import { intervalToDuration, parseISO } from 'date-fns';

export default function getInterval(dateString: string) {
  return intervalToDuration({
    start: parseISO(dateString),
    end: new Date()
  });
}
